"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = exports.BotAvatar = void 0;
var React = __importStar(require("react"));
var useImage_1 = require("../hooks/useImage");
var AvatarBase_1 = require("./AvatarBase");
var BotAvatar = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(AvatarBase_1.AvatarIconBase, __assign({ icon: "BOT" }, props)));
};
exports.BotAvatar = BotAvatar;
var Avatar = function (_a) {
    var mode = _a.mode, src = _a.src, props = __rest(_a, ["mode", "src"]);
    var hasLoaded = (0, useImage_1.useImage)(src).hasLoaded;
    if (hasLoaded) {
        return React.createElement(AvatarBase_1.AvatarImageBase, __assign({ src: src }, props));
    }
    return React.createElement(AvatarBase_1.AvatarIconBase, __assign({ mode: mode }, props));
};
exports.Avatar = Avatar;
//# sourceMappingURL=index.js.map